import type { ServiceWithSlots } from '../types/timeSlots';

interface ComputeVisibleServicesOptions {
  services: ServiceWithSlots[];
  /** Accepts the raw `specialEvent.serviceTypes` shape (string[]) without a cast. */
  eventServiceTypes?: readonly string[] | null;
}

/**
 * Decide which services to show on the service-selection step.
 *
 * Mirrors legacy meitre-frontend behavior:
 * 1. If a special event scopes the visible services, filter to that subset first.
 * 2. Among the remaining services, if any returned raw slots from search-all-hours
 *    (including `type: "No"` slots), show only those. If none have raw slots,
 *    keep every service so the user still reaches select-time and sees the
 *    empty-availability message there.
 *
 * Note: services excluded upstream (calendar `type: "not-available-closed"`)
 * never reach this helper; they are filtered out when building `servicesWithSlots`.
 */
export function computeVisibleServices({
  services,
  eventServiceTypes,
}: ComputeVisibleServicesOptions): ServiceWithSlots[] {
  const scoped = eventServiceTypes && eventServiceTypes.length > 0
    ? services.filter((s) => eventServiceTypes.includes(s.service))
    : services;

  const withRawSlots = scoped.filter((s) => s.hasRawSlots);
  return withRawSlots.length > 0 ? withRawSlots : scoped;
}
